/* eslint-disable react/no-deprecated */
/* eslint-disable no-undef */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import RootContainer from './containers/root/index';
import configureStore from './store';
import '@fortawesome/fontawesome-free/css/all.min.css';

const store = configureStore({});

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <RootContainer />
  </Provider>,
);

if (module.hot) {
  module.hot.accept();
}
